import { openPremiumLimitModal } from "@/src/components/pages/StepPage/components/apiCalls/Modals/modalsHandlers";
import { apiCallsModalStore } from "@/src/components/pages/StepPage/components/apiCalls/modalStore";
import { useTextUsModalStore } from "@/src/stores/useTextUsModalStore";
import { throwStopCallsError } from "@/src/components/pages/StepPage/components/apiCalls/sideEffects";
import type { AnalyticsAction } from "@/src/shared/config/analytics-config";

export function checkPremiumLimit(finalPremium: number, trackAnalyticEvent: (action: AnalyticsAction, formData?: any) => void) {
    if (finalPremium > 40000) {
        openPremiumLimitModal({
            onCancel: () => {
                trackAnalyticEvent?.("limit_modal_map");
                window.open(
                    "https://www.pzu.com.ua/useful/filials.html",
                    "_blank",
                );
                apiCallsModalStore.getState().close();
            },
            onSubmit: () => {
                trackAnalyticEvent?.("limit_modal_consultation");
                apiCallsModalStore.getState().close();
                useTextUsModalStore.getState().open();
            },
            onClose: () => {
                trackAnalyticEvent?.("limit_modal_close");
            },
            variant: "premium",
        });
        throwStopCallsError();
    }
}
